// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instructions {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    height: 75%;
    border-radius: 15px;
    background-color: #312a2c;
    z-index: 10;
    padding: 50px 100px;
    color: white;
    font-family: 'Mitr', sans-serif;
}

.instructions span {
    font-family: 'Mitr', sans-serif;
    position: absolute;
    top: 20px;
    right: 20px;
    background-color: #312a2c;
    color: white;
    cursor: pointer;
    font-size: 20px;
    line-height: 15px;
}

.instructions h1 {
    text-align: center;
    font-size: 40px;
    margin: 0;
}

.instructions h4, .instructions a {
    font-size: 15px;
    margin: 0;
    width: 100%;
    text-decoration: none;
    color: #3aa394;
}`, "",{"version":3,"sources":["webpack://./src/style/Instructions.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".instructions {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 40%;\n    height: 75%;\n    border-radius: 15px;\n    background-color: #312a2c;\n    z-index: 10;\n    padding: 50px 100px;\n    color: white;\n    font-family: 'Mitr', sans-serif;\n}\n\n.instructions span {\n    font-family: 'Mitr', sans-serif;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background-color: #312a2c;\n    color: white;\n    cursor: pointer;\n    font-size: 20px;\n    line-height: 15px;\n}\n\n.instructions h1 {\n    text-align: center;\n    font-size: 40px;\n    margin: 0;\n}\n\n.instructions h4, .instructions a {\n    font-size: 15px;\n    margin: 0;\n    width: 100%;\n    text-decoration: none;\n    color: #3aa394;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
